import {
  BUNITO_DONE_FAILED,
  BUNITO_DONE_REQUEST,
  BUNITO_DONE_SUCCESS,
} from "../../../../actions/Factory/Bunito/bunitoDone/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const bunitoDoneReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case BUNITO_DONE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case BUNITO_DONE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case BUNITO_DONE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
